import React, { Component } from 'react';
import JobsAssignment from './Commons/JobsAssignment.js'

export default class IWTJobs extends Component {
	render() {
		return (
			<div>
				<JobsAssignment operationName={'IWT Jobs'} processType={'INTER_WAREHOUSE_TRANSFER'} userType={'PICKING'} processPhase={'INGESTION'} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/IWTJobs.js